import React from "react";
import classNames from "classnames/bind";
import styles from "./VariationBadgesFortime.module.scss";

const cx = classNames.bind(styles);

interface AttributeSelectorProps {
  selectedVariation: any;
  selectedAttribute: any;
  handleAttributeSelect: (attribute: any) => void;
}

const AttributeSelector: React.FC<AttributeSelectorProps> = ({
  selectedVariation,
  selectedAttribute,
  handleAttributeSelect
}) => {
  if (!selectedVariation) {
    return null;
  }

  const unitAttributes = selectedVariation?.attributes?.filter((attribute: any) => attribute.type === "unit") || [];

  return (
    <div className={cx("attributeOptions")}>
      <div className={cx("attributeGrid")}>
        {unitAttributes.length > 1 && 
          unitAttributes.map((attribute: any) => {
            const isSelected = selectedAttribute?.id === attribute.id;
            return (
              <div
                key={attribute.id}
                className={cx(
                  "attributeCard",
                  isSelected && "selected"
                )}
                onClick={() => handleAttributeSelect(attribute)}
              >
                <div className={cx("attributeName")}>{attribute.name}</div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
};

export { AttributeSelector }; 